export default "__VITE_ASSET__BGpKoOzN__"